import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// "All pages": the media buyer / affiliate gets every live page, including new ones, automatically.
export function AllPagesToggle({ kind, id, value, onChange, testId, compact = false }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (user?.org_type !== "internal" || !["super_admin", "admin"].includes(user?.role)) return null;
  const flip = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/traffic-access/${kind}/${id}/all-pages`, { on: !value });
      toast.success(value ? "All pages turned off. They keep the pages ticked now." : "All pages on. They get every live page, including new ones.");
      onChange?.(data);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Couldn't change All pages");
    } finally {
      setBusy(false);
    }
  };
  return (
    <label className={`inline-flex items-center gap-1.5 cursor-pointer select-none ${compact ? "text-[9px]" : "text-[11px]"} uppercase tracking-widest`}
           title="Gets every live page automatically, including pages that go live later">
      <input type="checkbox" checked={!!value} onChange={flip} disabled={busy} data-testid={testId} className="w-3.5 h-3.5 accent-black" />
      <span className={value ? "font-bold text-emerald-800" : ""}>All pages</span>
      {!compact && <span className="normal-case tracking-normal text-zinc-500">{value ? "· gets every live page, including new ones" : "· only the pages ticked"}</span>}
    </label>
  );
}
